module.exports = __webpack_public_path__ + "media/images/lb/558-608623c8a2b4693d54ee75cefefb2971.svg";